import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	paginacao: paginacaoListagem('id', 25, 'ASC'),

	filtro: {
		numeroAtaOuNumeroProcessoOuIdProcessoOuObjeto: {
			default: null,
			label: 'Pesquisa',
			value: null,
		},
		objeto: {
			default: null,
			label: 'Objeto',
			value: null,
		},
		siglaOrgao: {
			default: null,
			label: 'Orgão',
			value: null,
		},
	},
}
